var _line, _line2, _circle, _path, _circle2, _path2, _circle3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoBrandStepCardPrinting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 725,
    height: 35,
    viewBox: "0 0 725 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 338,
    y1: 17.5,
    x2: 43,
    y2: 17.5,
    stroke: "#545454"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 683,
    y1: 17.5,
    x2: 391,
    y2: 17.5,
    stroke: "#545454"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 18,
    r: 17,
    fill: "#A4861E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 14L16.2 23L11 18.875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 366,
    cy: 18,
    r: 17,
    fill: "#A4861E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M372 14L365.2 23L360 18.875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 708,
    cy: 17,
    r: 17,
    fill: "#A4861E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M714 13L707.2 22L702 17.875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBrandStepCardPrinting);
export default __webpack_public_path__ + "static/media/noBrandStepCardPrinting.27a83fabc9d6faf5a75a3d57ef764a71.svg";
export { ForwardRef as ReactComponent };